import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import validator from 'validator'
import { Form, Segment, Button } from "semantic-ui-react";
import FormErrorMessage from "../../utils/FormErrorMessage";
import { updateOrCreateRelation, updateRelationModelInStore, loadUnmappedWooCustomers } from "../../../actions/relation";
import Dls from "../../../lib";

class RelationForm extends Component {
    constructor() {
        super();
        this.state = {
            errors: [],
            loading: false
        };
    }

    componentDidMount() {
        const {unmapped_relations, jwt} = this.props;
        if (unmapped_relations.length === 0) {
            this.loadWooUnmapped(jwt);
        }
        if (unmapped_relations.length === 1) {
            if (unmapped_relations[0].key === "0") {
                this.loadWooUnmapped(jwt);
            }
        }
    }

    onFormSubmit = () => {
        const {id, type} = this.props.model;
        const action = this.props.model.id ? "Update" : "Create";
        const errors = this.validateInput();
        if (_.isEmpty(errors)) {
            this.setState({
                loading: true
            });
            this.props
                .updateOrCreateRelation(this.props.jwt, this.props.model)
                .then(res => {
                    if (action === 'Create') {
                        this.props.history.push(`/${_.toLower(type)}s/${res.data.data.id}/view/${_.toLower(type)}`)
                    } else {
                        this.props.history.push(`/${_.toLower(type)}s/${id}/view/${_.toLower(type)}`)
                    }
                })
                .catch(err => {
                    const errors = Dls.apiErrorMessage(err);
                    this.setState({
                        loading: false,
                        errors: errors
                    });
                });
        } else {
            this.setState({
                errors: errors
            });
        }
    };


    loadWooUnmapped = (jwt) => {
        this.props.loadUnmappedWooCustomers(jwt).catch(err => {
            console.log(err);
        });
    }

    validateInput = () => {
        const { company_name, email } = this.props.model;
        const errors = [];
        if (!company_name) {
            errors.push("Company name is required");
        }
        if (email) {
            if (!validator.isEmail(email)) {
                errors.push("Eamil address is invalid");
            }
        }
        return errors;
    };

    render() {
        const {model, updateRelationModelInStore, isDirty, taxes, terms, unmapped_relations, users} = this.props
        return (
            <Form size="large">
                <Segment stacked>
                    {!_.isEmpty(this.state.errors) ? (
                        <FormErrorMessage errors={this.state.errors} />
                    ) : null}
                    <Form.Group unstackable widths={4}>
                        <Form.Input
                            fluid
                            label="Company Name"
                            name="company_name"
                            value={model.company_name ? model.company_name : ""}
                            onChange={(e) => { updateRelationModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Select fluid label='Status' options={[
                                {key: 'Active', text: 'Active', value: 'Active'},
                                {key: 'Disabled', text: 'Disabled', value: 'Disabled'}
                            ]} name="status" value={model.status ? model.status : "Active"}
                            onChange={(e,data) => { updateRelationModelInStore('status', data.value) }}
                        />
                        <Form.Input
                            fluid
                            label="First Name"
                            name="given_name"
                            value={model.given_name ? model.given_name : ""}
                            onChange={(e) => { updateRelationModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input
                            fluid
                            label="Last Name"
                            name="family_name"
                            value={model.family_name ? model.family_name : ""}
                            onChange={(e) => { updateRelationModelInStore(e.target.name, e.target.value) }}
                        />
                    </Form.Group>
                    <Form.Group unstackable widths={4}>
                        <Form.Input
                            fluid
                            label="Account"
                            name="account"
                            value={model.account ? model.account : ""}
                            onChange={(e) => { updateRelationModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input
                            fluid
                            label="Email"
                            name="email"
                            value={model.email ? model.email : ""}
                            onChange={(e) => { updateRelationModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input
                            fluid
                            label="Phone #"
                            name="phone"
                            value={model.phone ? model.phone : ""}
                            onChange={(e) => { updateRelationModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input
                            fluid
                            label="Qualified Name (QB)"
                            name="qualified_name"
                            value={model.qualified_name ? model.qualified_name : ""}
                            onChange={(e) => { updateRelationModelInStore(e.target.name, e.target.value) }}
                        />

                    </Form.Group>
                    <Form.Group unstackable widths={4}>
                        <Form.Input
                            fluid
                            label="Display Name (QB)"
                            name="display_name"
                            value={model.display_name ? model.display_name : ""}
                            onChange={(e) => { updateRelationModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input
                            fluid
                            label="Check Name (QB)"
                            name="check_name"
                            value={model.check_name ? model.check_name : ""}
                            onChange={(e) => { updateRelationModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Select fluid label='Default Tax'
                            options={taxes} name="status"
                            value={model.tax_id ? model.tax_id : 0}
                            onChange={(e,data) => { updateRelationModelInStore('tax_id', data.value) }}
                        />
                        <Form.Select fluid label='Default Term'
                            options={terms} name="status"
                            value={model.term_id ? model.term_id : 0}
                            onChange={(e,data) => { updateRelationModelInStore('term_id', data.value) }}
                        />
                    </Form.Group>
                    <Form.Group unstackable widths={4}>
                        <Form.Select fluid label='Default Currency' options={[
                                {key: 'CAD', text: 'CAD', value: 'CAD'},
                                {key: 'USD', text: 'USD', value: 'USD'}
                            ]} name="currency" value={model.currency ? model.currency : ""}
                            disabled={model.id ? true: false}
                            onChange={(e,data) => { updateRelationModelInStore('currency', data.value) }}
                        />
                        <Form.Select fluid label='Account Rep' options={
                                _.isArray(users) ? users : []
                            } name="rep_id" value={model.rep_id ? _.toString(model.rep_id) : "0"}
                                onChange={(e,data) => { updateRelationModelInStore('rep_id', data.value) }}
                        />
                        {model.id ? <Form.Select search fluid label='Woo User Map' options={unmapped_relations}
                            name="woo_id" value={model.woo_id ? model.woo_id : "0"}
                            onChange={(e,data) => { updateRelationModelInStore('woo_id', data.value) }}
                        /> : null}
                        {model.id ? <Form.Input
                            fluid
                            label="Quickbook ID"
                            name="acct_id"
                            value={model.acct_id ? model.acct_id : ""}
                            onChange={(e) => { updateRelationModelInStore(e.target.name, e.target.value) }}
                        />
                         : null}
                    </Form.Group>
                    <Button
                        color="teal"
                        onClick={this.onFormSubmit}
                        size="large"
                        loading={this.state.loading}
                        disabled={!isDirty}
                    >
                        Save
                    </Button>
                </Segment>
            </Form>
        );
    }
}

RelationForm.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    updateOrCreateRelation: PropTypes.func.isRequired,
    updateRelationModelInStore: PropTypes.func.isRequired,
    loadUnmappedWooCustomers: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    isDirty: PropTypes.bool.isRequired,
    jwt: PropTypes.string.isRequired,
    taxes: PropTypes.array.isRequired,
    terms: PropTypes.array.isRequired,
    users: PropTypes.array.isRequired,
    unmapped_relations: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        model: state.relation.model,
        isDirty: state.relation.dirty,
        jwt: state.auth.jwt,
        taxes: state.system.resources.taxes,
        terms: state.system.resources.terms,
        users: state.system.resources.users,
        unmapped_relations: state.system.woo.unmapped
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            updateOrCreateRelation,
            updateRelationModelInStore,
            loadUnmappedWooCustomers
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RelationForm);



// WEBPACK FOOTER //
// ./src/components/forms/relations/Relation.js